const productsModelObject = {
  methods: {
    productsModelObject() {
      return {
        NECK_BRACE: {
          name: "Minerve",
          table: this.$db.minerva,
          get: this.getMinerva,
          create: this.createMinerva
        },
        MOLDED_SEAT: {
          name: "Siège moulé",
          table: this.$db.molded_seat,
          get: this.getMoldedSeat,
          create: this.createMoldedSeat
        },
        OTN: {
          name: "OTN",
          table: this.$db.otn,
          get: this.getOtn,
          create: this.createOtn
        },
        LIFT: {
          name: "Verticalisateur",
          table: this.$db.lift,
          get: this.getLift,
          create: this.createLift
        },
        RETOUCHING_REPAIR: {
          name: "Retouche/Réparation",
          table: this.$db.retouching_repair,
          get: this.getRetouchingRepair,
          create: this.createRetouchingRepair
        },
        SEAT: {
          name: "Selle",
          table: this.$db.seat,
          get: this.getSeat,
          create: this.createSeat
        },
        POSITIONING_SEAT: {
          name: "Selle de positionnement",
          table: this.$db.positioning_seat,
          get: this.getPositioningSeat,
          create: this.createPositioningSeat
        },
        UPPER_LIMB_ORTHOSIS: {
          name: "Orthèse M sup",
          table: this.$db.upper_limb,
          get: this.getUpperLimb,
          create: this.createUpperLimb
        },
        LOWER_LIMB_ORTHOSIS: {
          name: "Orthèse M inf",
          table: this.$db.lower_limb,
          get: this.getLowerLimb,
          create: this.createLowerLimb
        },
        CORSET: {
          name: "Corset",
          table: this.$db.corset,
          get: this.getCorset,
          create: this.createCorset
        }
      };
    }
  }
};

export { productsModelObject };
